import { Variants, VariantStyles } from '../Variants';
import {
  LTTooltip,
  LTText as LTTextComponent,
} from '@lambdatestincprivate/lt-components';

import './style.css';

const LTText = ({
  children,
  className,
  variant = Variants.PRIMARY,
  size = 0,
  weight = 0,
  lineHeight = '18',
  color, // eg: '#999'
  as,
  text,
  tooltipText = '',
  tooltipDirection = 'top',
  ...rest
}) => {
  const extraStyles = {};
  if (size) {
    extraStyles.fontSize = `${size}px`;
  }
  if (weight) {
    extraStyles.fontWeight = weight;
  }
  if (color) {
    extraStyles.color = color;
  }
  if (lineHeight) {
    extraStyles.lineHeight = `${lineHeight}px`;
  }
  let textComponent = (
    <LTTextComponent
      as={as}
      className={`lt-text-component responsive-text-${variant} ${
        !!tooltipText ? '' : className
      }`}
      style={{ ...VariantStyles[variant], ...extraStyles }}
      {...rest}
    >
      {text ? text : children}
    </LTTextComponent>
  );

  if (tooltipText) {
    textComponent = (
      <LTTooltip
        className={className}
        text={tooltipText}
        direction={tooltipDirection}
      >
        {textComponent}
      </LTTooltip>
    );
  }

  return textComponent;
};

LTText.Variant = Variants;

export default LTText;
